import React, { useEffect, useState } from "react";
import "./deletedUsers.css";
import api from "../../api/axios.js";


const DeletedUsers = () => {
  const [users, setUsers] = useState([]);
  const [filter, setFilter] = useState("all");
  const [loading, setLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState(null);

  const fetchDeletedUsers = async (role = "all") => {
    try {
      setLoading(true);

      const params = {
        // status:"pending",
        page: 1,
        limit: 10,
      };
      if (role !== "all") params.role = role;

      const res = await api.get("/admin/delete-requests", { params });

      setUsers(res.data.data || []);
    } catch (err) {
      console.error("Failed to load deleted users", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDeletedUsers(filter);
  }, [filter]);

  const handleApprove = async (id) => {
    try {
      setActionLoading(id);
      await api.put(`/admin/delete-requests/${id}/approve`);
      fetchDeletedUsers(filter);
    } catch (err) {
      console.error("Approve failed", err);
    } finally {
      setActionLoading(null);
    }
  };

  const handleReject = async (id) => {
    try {
      setActionLoading(id);
      await api.put(`/admin/delete-requests/${id}/reject`);
      fetchDeletedUsers(filter);
    } catch (err) {
      console.error("Reject failed", err);
    } finally {
      setActionLoading(null);
    }
  }

  return (
    <div className="deleted-users-page slide-in">
      {/* Header */}
      <div className="page-header">
        <div>
          <h1>Deleted Users</h1>
          <p>Review deleted user requests and take action</p>
        </div>

        {/* Filters */}
        <div className="filter-groupp">
          {["all", "vendor", "customer", "advisor"].map((type) => (
            <button
              key={type}
              className={filter === type ? "active" : ""}
              onClick={() => setFilter(type)}
            >
              {type.charAt(0).toUpperCase() + type.slice(1)}
            </button>
          ))}
        </div>
      </div>

      {/* Table */}
      <div className="table-card">
        {loading ? (
          <div className="table-loading">Loading deleted users...</div>
        ) : (
          <table className="deleted-users-table">
            <thead>
              <tr>
                <th>User</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Role</th>
                <th>Reason</th>
                <th>Requested</th>
                <th>Deleted At</th>
                <th>Deleted By</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {users.map((item, index) => (
                <tr key={item._id} style={{ animationDelay: `${index * 0.08}s` }}>
                  <td className="user-cell">
                    <img
                      src={item.user?.profile_image || "/avatar.png"}
                      alt=""
                    />
                    <span>{item.user?.name || '(Deleted)'}</span>
                  </td>
                  <td>{item.user?.email?.trim() || 'N/A'}</td>
                  <td>{item.mobile_number || item.user?.mobile_number || 'N/A'}</td>
                  <td>
                    <span className={`role-badge ${item.primaryRole}`}>
                      {item.primaryRole || 'N/A'}
                    </span>
                  </td>
                  <td>{item.reason || '—'}</td>
                  <td>{item.createdAt ? new Date(item.createdAt).toLocaleDateString('en-IN') : '—'}</td>
                  <td>
                    {item.user?.isDeleted
                      ? <span style={{ color: '#888', fontSize: 12 }}>{item.user.deletionApprovedAt ? new Date(item.user.deletionApprovedAt).toLocaleDateString('en-IN') : 'Deleted'}</span>
                      : '—'
                    }
                  </td>
                  <td>
                    <span style={{ fontSize: 12, color: item.approvedBy ? '#7b2d2d' : '#555' }}>
                      {item.approvedBy ? 'Admin' : 'User'}
                    </span>
                  </td>

                  <td>
                    {item.status === 'cancelled' && (
                      <span style={{ fontSize: 12, color: '#555' }}>Cancelled (user logged in)</span>
                    )}
                    {item.status !== 'rejected' && item.status !== 'cancelled' && <button
                      className={`approve-btn ${item.status !== 'approved' ? 'disabled' : ''}`}
                     disabled={item.status === 'approved' || actionLoading === item._id}
                      onClick={() => handleApprove(item._id)}
                    >
                      {item.status === 'approved' ? 'Approved' : 'Approve'}
                    </button>}
                    {item.status !== 'approved' && item.status !== 'cancelled' && <button
                      className="reject-btn"
                     disabled={item.status === 'rejected' || actionLoading === item._id}
                      onClick={() => handleReject(item._id)}
                    >
                      {item.status === 'rejected' ? 'Rejected' : 'Reject'}
                    </button>}
                  </td>
                </tr>
              ))}

              {users.length === 0 && (
                <tr>
                  <td colSpan="5" className="empty">
                    No deleted users found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
export default DeletedUsers;
